import { DuperbrowseState } from './types';

export const reduxKey = '@@DUPERBROWSE';
export const actionKey = '@@DUPERBROWSE';

export const initialState: DuperbrowseState = {
  streamStack: [],
  isSessionActive: false,
  isHistoryManagementEnabled: true,
};

export const FEEDBACK_PAGE_DUPERBROWSE_STREAMID = `${reduxKey}:FB:STREAM`;
export const FEEDBACK_PAGE_DUPERBROWSE_ITEMID = `${reduxKey}:FB:ITEM`;
export const DAMZ_PAGE_DUPERBROWSE_STREAMID = `${reduxKey}:DAMZ:STREAM`;
export const DAMZ_PAGE_DUPERBROWSE_ITEMID = `${reduxKey}:DAMZ:ITEM`;
